import React from 'react';
import {MainLoader} from '@chekin/guestapp-ui-kit';
import {useCustomLotties} from '../../hooks/useCustomLotties';
import {ModalProps} from '@guestapp/old-ui-kit';
import {AltText, Icon, StatusModalStates} from './constants';
import {StyledModal} from './styled';

const defaultIconProps = {width: 60, height: 60};
type StatusModalProps = ModalProps & {state?: StatusModalStates};

const StatusModal = React.memo(
  ({
    state = StatusModalStates.LOADING,
    iconAlt: passedIconAlt,
    iconSrc: passedIconSrc,
    iconProps: passedIconProps,
    ...props
  }: StatusModalProps) => {
    const {successAnimationIcon} = useCustomLotties();
    const icon = React.useMemo(() => {
      if (state === StatusModalStates.LOADING) {
        return {
          element: <MainLoader visible width={60} />,
        };
      }
      if (state === StatusModalStates.SUCCESS) {
        return {
          lottie: successAnimationIcon,
        };
      }
      return {
        src: passedIconSrc || Icon[state],
        alt: passedIconAlt || AltText[state],
        props: passedIconProps || defaultIconProps,
      };
    }, [passedIconAlt, passedIconProps, passedIconSrc, state, successAnimationIcon]);

    return (
      <StyledModal
        iconElement={icon.element}
        iconSrc={icon.src}
        iconAlt={icon.alt}
        iconProps={icon.props}
        iconLottie={icon.lottie}
        {...props}
      />
    );
  },
);

export {StatusModal};
